<div #assetGalleryRef class="assets-gallery-view relative">
  <cdk-virtual-scroll-viewport
    class="flex flex-row"
    [ngClass]="dashboardFlag ? '!overflow-hidden h-full' : configObject && configObject?.callFrom === 'createProject' ? configObject?.rowHeight : 'h-full'"
    #scroller
    [itemSize]="itemHeight"
    (window:resize)="changeProgress()"
  >
    <div class="image row pl-2 h-full" *cdkVirtualFor="let assetRow of imageSplitObject; let rowIndex = index">
      <div
        *ngFor="let asset of assetRow; let i = index"
        [class]="configObject?.className"
        [ngClass]="getAssetClasses()"
        id="{{ rowIndex }}-{{ i }}"
        class="asset-gallery-item card w-full h-auto inline-block"
        [attr.data-test-id]="'assets_card_thumbnail'"
        [attr.asset-id]="asset._id"
      >
        <div
          class="asset-gallery-item-inner h-auto mr-6 mb-6 bg-white rounded-lg shadow hover:shadow-xl relative"
          [ngClass]="{ '!mr-2': projectFlag || relationFlag, '!mb-4': dashboardFlag || relationFlag }"
        >
          <div
            class="asset-gallery-image-container asset-image-box relative w-full flex justify-center items-center cursor-pointer rounded-lg overflow-hidden"
            [class.opacity-40]="isAssetPlannedOrUnpublished(asset)"
            (click)="openModal(asset, rowIndex, i)"
          >
            <!-- Disabling pointer events on expired images, to hide the 'save as image' menu on right click -->
            <a
              (click)="openModal(asset, rowIndex, i, false)"
              [routerLink]="asset.status !== Status.Draft && enableAssetDetailsLink ? (asset._id | assetLink: configObject?.callFrom === 'shareAssets') : null"
              class="asset-gallery-image-link"
            >
              <img
                *ngIf="asset.imageUrl"
                class="asset-gallery-image"
                [src]="asset.imageUrl | imageLoading | async"
                [alt]="asset.name"
                [style.pointerEvents]="!(asset.expiryDate | dateNotExpired) ? 'none' : 'all'"
              />
              <div *ngIf="!asset.previewUrl && (asset.expiryDate | dateNotExpired) && asset.assetType !== AssetType.Zip" class="h-full w-full flex justify-center items-center px-4">
                <span class="text-xl font-bold" i18n>Preview Not Available</span>
              </div>
            </a>

            <!-- Overlay for expired assets  -->
            <a
              (click)="openModal(asset, rowIndex, i, false)"
              [routerLink]="asset.status !== Status.Draft && enableAssetDetailsLink ? (asset._id | assetLink: configObject?.callFrom === 'shareAssets') : null"
              class="h-full w-full absolute top-0 left-0"
            >
              <!-- Overlay for expired assets  -->
              <sp-overlay class="asset-overlay-semitransparent px-4" *ngIf="!(asset.expiryDate | dateNotExpired)">
                <span class="text-xl font-bold" i18n>Expired</span>
              </sp-overlay>
              <!-- Overlay for archived assets  -->
              <sp-overlay class="asset-overlay-semitransparent px-4" *ngIf="asset.status === Status.Archived">
                <span class="text-xl font-bold" i18n>Archived</span>
              </sp-overlay>
              <!-- Overlay for draft assets  -->
              <sp-overlay class="asset-overlay-semitransparent px-4" *ngIf="asset.status === Status.Draft">
                <span class="text-xl font-bold" i18n>Draft</span>
              </sp-overlay>

              <div *ngIf="asset.previewUrl && asset.assetType === AssetType.PowerpointPresentation" class="text-xl font-bold h-full w-full flex justify-center items-center">
                <mat-icon class="cursor-pointer mr-2 material-icons-outlined">description</mat-icon>
                <ng-container i18n>Click to preview</ng-container>
              </div>
              <div *ngIf="asset.assetType === AssetType.Audio" class="font-bold h-full w-full flex justify-center items-center">
                <mat-icon class="cursor-pointer mr-2 material-icons-outlined icon-large">audiotrack</mat-icon>
              </div>
              <div *ngIf="asset.assetType === AssetType.Zip" class="font-bold h-full w-full flex justify-center items-center">
                <mat-icon class="cursor-pointer mr-2 material-icons-outlined icon-large">folder_zip</mat-icon>
              </div>
            </a>
          </div>

          <!-- Keeping this checkbox after overlay component, so that it's visible  -->
          <ng-template [ngIf]="(checkboxAccessibility(asset) || sharedAssetsFlag) && !noDownload">
            <div class="asset-gallery-checkbox-container" *ngIf="projectFlag || sharedAssetsFlag || configObject?.emitSelectedAssets">
              <mat-checkbox class="example-margin" (change)="onChange($event, asset)" [checked]="asset?.checked"> </mat-checkbox>
            </div>
            <div class="asset-gallery-checkbox-container" *ngIf="!projectFlag && !dashboardFlag && !sharedAssetsFlag && !configObject?.emitSelectedAssets">
              <mat-checkbox class="example-margin" (change)="onAddRemoveFromBasket(asset)" [checked]="asset?.isAddedToBasket"> </mat-checkbox>
            </div>
          </ng-template>
          <div class="asset-item-titel-row flex justify-between pl-3 pt-1 w-[97%]">
            <span class="truncate pr-4" [matTooltip]="asset.name">{{ asset.name }}</span>
            <div class="flex gap-2 items-center" *ngIf="asset.plannedDeletion || asset.expiryDate || asset.publishStartDate || asset.publishEndDate">
              <sp-expiry-days-warning *ngIf="!dashboardFlag && !projectFlag && asset.expiryDate && (asset.assetExpiryDays || asset.assetExpiryDays === 0)" [asset]="asset"></sp-expiry-days-warning>
              <sp-plan-deletion-warning *ngIf="!dashboardFlag && !projectFlag && asset.plannedDeletion" [asset]="asset"></sp-plan-deletion-warning>
              <!-- Asset publishing message -->
              <div *ngIf="(!dashboardFlag && !projectFlag && asset.publishStartDate && !getIsAssetPublished(asset)) || asset.publishEndDate" class="flex items-center">
                <mat-icon class="material-icons-outlined mt-[-3px]" [matTooltip]="asset | assetPublishingMessage">schedule</mat-icon>
              </div>
            </div>
          </div>
          <div *ngIf="configObject?.showMetaData" class="flex justify-between pl-3 pt-1 w-[97%]">
            <span class="w-[70%] truncate" [matTooltip]="asset.metadata.assetMedium"><strong>Medium:</strong> {{ asset.metadata.assetMedium }}</span>
            <span *ngIf="asset.metadata.duration" class="w-[15%]text-right" ngClass="{'px-2': asset.assetType !== 'Audio' && asset.metadata.aspectRatio }">{{
              asset.metadata.duration | spTimeFormat
            }}</span>
            <span *ngIf="asset.assetType !== 'Audio' && asset.metadata.aspectRatio" class="w-[15%]text-right">{{ asset.metadata.aspectRatio }}</span>
          </div>
          <div *ngIf="configObject?.showMetaData && (asset.customFields.motive || asset.customFields.region)" class="flex justify-between pl-3 pt-1 w-[97%]">
            <span *ngIf="asset.customFields.motif" class="w-[50%] truncate" [matTooltip]="asset.customFields.motif"><strong>Motif:</strong> {{ asset.customFields.motif }}</span>
            <span *ngIf="asset.customFields.region" class="w-[50%] truncate text-right" [matTooltip]="asset.customFields.region"> <strong>Zielgruppe:</strong> {{ asset.customFields.region }}</span>
          </div>
          <div *ngIf="!dashboardFlag && !projectFlag" class="asset-item-footer flex justify-between pt-2 pb-1">
            <div class="flex justify-center items-center ml-3" [ngClass]="{ 'opacity-40': brandingKey === CustomClients.Vorwerk }">
              <mat-icon
                class="material-icons-outlined asset-type-icon"
                [svgIcon]="assetCommonService.getIcon(asset.assetType)"
                i18n-matTooltip
                [matTooltip]="asset.assetType | assetTypeTranslation"
              ></mat-icon>
              <!-- Asset status icon -- Need to handle  matTooltip translation scenario-->
              <mat-icon
                *ngIf="showAssetStatusIcon && (asset.status === Status.Uploaded || asset.status === Status.AwaitingApproval)"
                class="material-icons-outlined asset-status-icon ml-1"
                [svgIcon]="assetCommonService.getStatusIcon(asset.status, brandingKey)"
                i18n-matTooltip
                [matTooltip]="asset.status | optionsLabel: defaultAllStatusList"
              ></mat-icon>
              <mat-progress-spinner *ngIf="asset.inProgress" class="ml-3" mode="determinate" [value]="asset.downloadPercent" [diameter]="22"> </mat-progress-spinner>
            </div>
            <div class="flex">
              <thehubz-asset-gallery-card-actions
                *ngIf="!assetUploadStepperFlag && !sharedAssetsFlag"
                [asset]="asset"
                [configObject]="configObject"
                [collectionOwner]="collectionOwner"
                [collectionFlag]="collectionFlag"
                [currentWindowSize]="currentSize"
                [gridSettingsKeySuffix]="gridSettingsKeySuffix"
                [assetIndex]="i"
                (editDraftAsset)="editDraftAssetData($event)"
                (deleteAsset)="onDeleteAsset($event.asset, $event.id, $event.planDeletionFlag)"
                (downloadAsset)="onDownloadAsset($event.asset, $event.name)"
                (addRemoveFromBasket)="onAddRemoveFromBasket($event)"
                (editAsset)="editAssets.emit($event)"
                (viewAsset)="viewAsset.emit($event)"
              ></thehubz-asset-gallery-card-actions>
            </div>
          </div>
        </div>
      </div>
    </div>
  </cdk-virtual-scroll-viewport>
  <div #progressBarContainer class="absolute left-0 z-50 w-full bottom-0" *ngIf="assetCount > 0 && !dashboardFlag && !projectFlag && !assetUploadStepperFlag && brandingKey === CustomClients.Vorwerk">
    <thehubz-asset-progress-bar [lastVisibleAssetIndex]="lastVisibleAssetIndex" [assetCount]="assetCount"></thehubz-asset-progress-bar>
  </div>

  <!--
    This anchor targets the 3 dot menu of an asset but
    needs to be placed outside of the gallery-card-actions,
    otherwise it could not be found and would be skipped.
  -->
  <span
    *ngIf="isGuidedTourEnabled"
    tourAnchor="asset-grid-item-quick-action.anchor.toggle"
    data-guided-tour-controls="asset-menu-button"
    class="guided-tour-target absolute overlay-target sealed adjust-position"
  ></span>
</div>
